import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { HlmButton } from '@spartan-ng/helm/button';
import { HlmDropdownMenuImports } from '@spartan-ng/helm/dropdown-menu';

import { UserService } from '../../../auth/store/user.service';

@Component({
  selector: 'app-user-menu',
  imports: [NgOptimizedImage, HlmButton, HlmDropdownMenuImports],
  templateUrl: './user-menu.component.html',
})
export class UserMenuComponent {
  readonly #userService = inject(UserService);

  protected deconnexion() {
    this.#userService.signOut();
  }
}
